export const MOCK_ASSETS_RESPONSE = {
  results: [
    {
      id: 'mock-asset-1',
      host: 'example.com',
      score: 'B',
      timestamp: '2024-11-15T09:45:00Z',
      timestamp_jalali: '1403/08/25 09:45',
      thumbnail: null,
      screen_shot: null,
      ports: [80, 443, 8080],
      total_vulnerabilities: 6,
      vulnerabilities: { critical: 1, high: 2, medium: 2, low: 1, info: 0 },
    },
    {
      id: 'mock-asset-2',
      host: 'api.example.com',
      score: 'A',
      timestamp: '2024-11-15T09:50:00Z',
      timestamp_jalali: '1403/08/25 09:50',
      thumbnail: null,
      screen_shot: null,
      ports: [443],
      total_vulnerabilities: 1,
      vulnerabilities: { critical: 0, high: 0, medium: 1, low: 0, info: 0 },
    },
    {
      id: 'mock-asset-3',
      host: 'shop.example.com',
      score: 'C',
      timestamp: '2024-11-15T09:55:00Z',
      timestamp_jalali: '1403/08/25 09:55',
      thumbnail: null,
      screen_shot: null,
      ports: [80, 443],
      total_vulnerabilities: 9,
      vulnerabilities: { critical: 2, high: 3, medium: 3, low: 1, info: 0 },
    },
  ],
  current_page: 1,
  total_pages: 1,
}

export const MOCK_ASSET_FILTER_OPTIONS = {
  score: ['A', 'B', 'C', 'D', 'F'],
  ports: [80, 443, 8080],
}

export const MOCK_ASSET_DETAIL = {
  id: 'mock-asset-1',
  host: 'example.com',
  is_active: true,
  timestamp: '2024-11-15T09:45:00Z',
  timestamp_jalali: '1403/08/25 09:45',
  created_at: '2024-11-01T00:00:00Z',
  score: 'B',
  ip: [{ version: 'ipv4', ip: '93.184.216.34' }],
  ssl: { score: 'A' },
  scan_list: [{ id: 'mock-scan-1', label: '2024-11-15' }],
  selected_scan: ['mock-scan-1'],
  vulnerabilities: { critical: 1, high: 2, medium: 2, low: 1, info: 0 },
  total_vulnerabilities: 6,
  // Findings opened and closed per day. `[]` here was not merely empty — it was the
  // wrong SHAPE, so alignedFindingsTrend() fell through to its placeholder and the
  // guided tour showed a flat line where the product shows a trend.
  vulnerabilities_over_time: {
    x: ['2024-11-11', '2024-11-12', '2024-11-13', '2024-11-14', '2024-11-15'],
    new: [2, 0, 3, 1, 0],
    closed: [0, 1, 0, 2, 1],
  },
  vulnerabilities_list: [],
  dns: null,
  ports: [{ port: 80, protocol: 'tcp', service: 'http' }, { port: 443, protocol: 'tcp', service: 'https' }],
  techs: [{ name: 'Nginx', version: '1.24.0' }, { name: 'React', version: '18.2' }],
  screenshots: [],
  // A declared valuation — so the Asset Insights Business-value card renders
  // its declared state during the tour rather than the "not valued" empty one.
  value: {
    criticality: 'high',
    owner: 'Platform Team',
    environment: 'production',
    data_classification: 'confidential',
    notes: 'Primary marketing site — customer-facing, PCI scope for checkout.',
    updated_by: { id: 'mock-user-1', email: 'demo@example.com' },
    updated_at: '2024-11-10T08:00:00Z',
    created_at: '2024-10-01T08:00:00Z',
  },
}
